<template lang="pug">
  orders-container
</template>

<script>
// ----- DO NOT PUT ANY LOGIC HERE ------
// This file is used only for debugging, it's not used for standalone build

import OrdersContainer from '@/OrdersContainer'

export default {
  name: 'App',
  components: {
    OrdersContainer
  }
}
</script>

<style lang="stylus" scoped>
</style>
